export const MAIN_COMPANY = {
  address: '36 Distillery Lane, Suite 500 Toronto ON, M5A 3C4',
  website: 'https://property.ca',
};
